import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTimeout from 'react-timeout';
import { connect } from 'react-redux';
import _ from 'lodash';
import { checkAuthentication, getEntitlements } from 'helpers/auth.clientless';
import { getAuthorizedResources } from 'components/AuthClientless/AuthHelper';
import { getMVPDCookie, setMVPDCookie, removeMVPDCookie } from 'helpers/ContentHelper';
import { clientlessRecurringPreAuthZRefresh, tveEnabled } from 'helpers/ConfigHelper';
import { getAdditionalAuthorizedNetworks, MVPD_COOKIE_NAME } from 'helpers/AuthHelper';
import { getDefaultClientlessOptions } from 'helpers/AuthClientlessHelper';
import { setPreauthorizedResourcesAction } from 'index/AppActions';

const REFRESH_INTERVAL_MS = clientlessRecurringPreAuthZRefresh();
class PreauthRefresh extends Component {
  componentDidMount() {
    this.refreshPreauthorizedResources(REFRESH_INTERVAL_MS);
  }

  componentWillUnmount() {
    const { clearInterval } = this.props;
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  checkClientlessPreauthorizedResources = async () => {
    const {
      accessToken,
      deviceId,
      setAuthorizationToken,
      setMVPDToAppState,
      setPreauthRefreshComplete,
      setPreauthorizedResources,
      setProvider,
    } = this.props;
    const additionalAuthorizedNetworks = getAdditionalAuthorizedNetworks();
    const options = {
      ...getDefaultClientlessOptions(),
      accessToken,
      deviceId,
      ignoreCache: true,
      mvpdCookieName: MVPD_COOKIE_NAME,
      setMVPDToAppState,
      setProvider,
    };

    let authResult;
    try {
      authResult = await checkAuthentication(options);
    } catch (error) {
      setPreauthRefreshComplete(true);
      return;
    }
    const newAccessToken = _.get(authResult, 'accessToken');
    setAuthorizationToken(newAccessToken);
    const getEntitlementsOptions = {
      ...options,
      accessToken: newAccessToken,
      ignoreCache: true,
      setMVPDToAppState,
    };

    let getEntitlementsResult = null;
    try {
      getEntitlementsResult = await getEntitlements(getEntitlementsOptions);
    } catch (error) {
      console.error('getEntitlements error', error);
    }
    const entitlements = _.get(getEntitlementsResult, 'entitlements', {});
    const preAuthorizedNetworks = getAuthorizedResources(
      _.keys(entitlements),
      additionalAuthorizedNetworks,
    );

    this.updateMVPDCookie(preAuthorizedNetworks);
    setPreauthorizedResources(preAuthorizedNetworks);
    setPreauthRefreshComplete(true);
  };

  refreshPreauthorizedResources = interval => {
    const { setInterval } = this.props;
    if (!tveEnabled()) return;
    this.checkClientlessPreauthorizedResources();
    this.interval = setInterval(this.checkClientlessPreauthorizedResources, interval);
  };

  updateMVPDCookie = preAuthorizedResources => {
    const mvpdCookie = getMVPDCookie();
    if (mvpdCookie) {
      removeMVPDCookie({ options: { path: '/' } });
      mvpdCookie.preauthorizedResources = preAuthorizedResources;
      setMVPDCookie({ value: mvpdCookie, options: { path: '/' } });
    }
  };

  render() {
    return null;
  }
}

PreauthRefresh.defaultProps = {
  accessToken: null,
  setAuthorizationToken: () => {},
  setMVPDToAppState: () => {},
};

PreauthRefresh.propTypes = {
  accessToken: PropTypes.string,
  clearInterval: PropTypes.func.isRequired,
  deviceId: PropTypes.string,
  setAuthorizationToken: PropTypes.func,
  setInterval: PropTypes.func.isRequired,
  setMVPDToAppState: PropTypes.func,
  setPreauthRefreshComplete: PropTypes.func.isRequired,
  setPreauthorizedResources: PropTypes.func.isRequired,
  setProvider: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setPreauthorizedResources: setPreauthorizedResourcesAction,
};

export default connect(
  null,
  mapDispatchToProps,
)(ReactTimeout(PreauthRefresh));
